<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('csvShipmentImport') }}
        </h1>
        <h1>
          <!-- {{ $tc('models.servicePostalCode', 2) }} -->
          <v-btn color="primary" @click="save" outline :loading="loading" :disabled="loading" v-if="inputFile"> {{ $t('save') }} </v-btn>
          <v-btn color="primary" outline @click="back"> {{ $t('back') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field :label="$t('selectFile')" @click="pickFile" v-model="filename" prepend-icon="attach_file"></v-text-field>
                <!-- .csv, -->
                <input type="file" style="display: none" ref="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="onFilePicked">
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shipment from '@/client/shipment'

export default {
  name: 'ShipmentImportView',

  props: {},

  data () {
    return {
      filename: '',
      inputFile: '',
      countryId: '',
      service: {},
      countries: [],
      model: '',
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    onFilePicked (e) {
      this.loading = true
      this.errors.clear()

      this.inputFile = e.target.files[0]
      this.filename = this.inputFile.name
      this.loading = false
    },

    pickFile () {
      this.$refs.file.click()
    },

    async fetch () {
      this.loading = true
      this.loading = false
    },

    async save () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }
      this.loading = true
      try {
        const formData = new FormData()
        formData.append('files[]', this.inputFile)
        await Shipment.importCsvShipment(formData)
        this.setNotification({
          color: 'success',
          message:  `Shipments imported successfully.` //this.$t('servicePOstalCodeImportSuccess')
        })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
